import React, { useState } from 'react';
import { ArrowLeft } from 'react-bootstrap-icons';

import { Button } from '../../components/Button';
import { Footer as FooterStyled, RightGroupStyled } from './FooterStyled';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import { useRoutes } from 'hooks';

type Props = {
  onSave?: any;
  onDiscardChanges?: any;
  discardText?: string;
  isDiscardChangesDisabled?: boolean;
  isSaveDisabled?: boolean;
  isLoading: boolean;
  showReturnHome?: boolean;
  style?: any;
  className?: string;
  showEditButtons?: boolean;
  isDirty?: boolean;
};

export const Footer: React.FC<Props> = ({
  onSave,
  onDiscardChanges,
  isDiscardChangesDisabled,
  isSaveDisabled,
  isLoading,
  discardText,
  showReturnHome,
  style,
  className,
  showEditButtons,
  isDirty = false,
}) => {
  const { returnHome } = useRoutes();
  const [isDiscardChangesOpen, setIsDiscardChangesOpen] = useState(false);

  return (
    <>
      <ConfirmModal
        show={isDiscardChangesOpen}
        onClose={() => {
          setIsDiscardChangesOpen(false);
        }}
        message="Are you sure you'd like to discard your changes?"
        onConfirm={() => {
          setIsDiscardChangesOpen(false);
          onDiscardChanges();
        }}
        title='Discard Changes'
        size='md'
        confirmLabel='Discard'
        testid='discard-changes-modal'
        isCentered
      />
      <FooterStyled className={className} style={style}>
        {showReturnHome ? (
          <Button variant='secondary' onClick={returnHome}>
            <ArrowLeft />
            Return Home
          </Button>
        ) : (
          <div></div>
        )}
        {showEditButtons && (
          <RightGroupStyled>
            <Button
              variant='secondary'
              data-testid='footer-discard-button'
              onClick={() => {
                if (isDirty) {
                  setIsDiscardChangesOpen(true);
                } else {
                  onDiscardChanges();
                }
              }}
              disabled={isDiscardChangesDisabled}
            >
              {discardText ?? 'Discard Changes'}
            </Button>
            <Button
              variant='primary'
              type='submit'
              data-testid='footer-save-button'
              loading={isLoading}
              onClick={onSave}
              disabled={isSaveDisabled}
            >
              {isLoading ? '' : 'Save'}
            </Button>
          </RightGroupStyled>
        )}
      </FooterStyled>
    </>
  );
};
